import { ActionPlugin } from '../Action/plugin'
import { ActionCallPageNode } from './TypedNode'

import type { RehajePlugin } from '@rehaje/core'

export class ActionCallPagePlugin implements RehajePlugin {
  constructor() {
    return new ActionPlugin({
      actions: {
        CallPage: ActionCallPageNode
      }
    })
  }
}
